// extracted by mini-css-extract-plugin
export default {"widgetContainer":"ranked-entities_widgetContainer__SkSIP"};